import { useMemo } from "react";

import * as COLUMNS_AVAILABLE from "b2b/components/zdroje-typy-grid-columns/columnsAvailable";

export default function useColumns() {
  const columns = [
    COLUMNS_AVAILABLE.name(),
    COLUMNS_AVAILABLE.vyznam(),
    COLUMNS_AVAILABLE.popis()
  ];
  return useMemo(() => [columns], []);
}
